import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import MaterialTable, { Column } from 'material-table';
import Fab from '@material-ui/core/Fab';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import { Tooltip, WithStyles, IconButton } from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { NotificationsType } from 'src/reducers/landingPage';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import StarBorderIcon from '@material-ui/icons/StarBorder';

interface TableState {
    columns: Array<Column<NotificationsType>>;
    data: NotificationsType[];
}

export interface PaidInvoicePageProps {
    notifications: NotificationsType[];
    readNotification: (notification: NotificationsType) => void;
    reload: () => void;
    onRowClick: (notification: NotificationsType) => void;
    readAllNotification: () => void;
    onRowClickFbStatus: (orderid: string, rowData: string, feedbackreview: string) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        table: {
            // margin: theme.spacing(1),
            minWidth: 500,
        },
        iconbutton: {
            display: 'flex',
            '& > *': {
                margin: theme.spacing(1),
            },
            justifyContent: 'center'
        },
        color: {
            backgroundColor: '#23a710e6',
            color: '#fff'
        },
        paymentButton: {
            // margin: theme.spacing(1),
            float: 'right',
            zIndex: 100,
            // margin: '12px',
            position: 'absolute',
            right: 0,
            backgroundColor: 'transparent',
            boxShadow: 'none',
            '&:hover': {
                backgroundColor: 'transparent',
                boxShadow: 'none',
            }
        },
        dialogContent: {
            textAlign: 'center',
            fontWeight: 'bolder',
            fontSize: '50px'
        },
        dialogContentAlert: {
            textAlign: 'center',
            fontWeight: 'bolder',
            fontSize: '30px'
        },
        money: {
            color: '#8bc34a',
            fontSize: 40,
            margin: '0 5px',
        },
        dialogTitle: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '10px'
        },
        dialogAction: {
            justifyContent: 'center',
        },
        iconClose: {
            position: 'absolute',
            right: 0
        },
        underline: {
            textDecoration: 'underline',
            textTransform: 'uppercase'
        },
        right: {
            textAlign: 'right',
            fontWeight: 500,
            fontSize: '25px',
            color: '#212121'
        },
        left: {
            textAlign: 'left',
            fontWeight: 500,
            fontSize: '25px',
            color: '#212121'
        },
        popTitle: {
            color: '#3F51B5'
        },
        buttonSend: {
            // margin: theme.spacing(1),
            float: 'right',
            zIndex: 100,
            margin: '10px',
            position: 'relative'
        },
        HeadinG: {
            margin: theme.spacing(1),
            '& .MuiInputBase-input': {
                fontSize: '0.9rem'
            },
            '& .MuiButton-label': {
                fontSize: '0.7rem'
            },
            fontSize: '0.9rem'
        }
    })
);

const styles = (theme: Theme) =>
    createStyles({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });

export interface DialogTitleProps extends WithStyles<typeof styles> {
    id: string;
    children: React.ReactNode;
    onCloseD: () => void;
}

export const PaidInvoiceView: React.StatelessComponent<PaidInvoicePageProps> = (props) => {    
    const classes = useStyles({});

    const [state] = React.useState<TableState>({
        columns: [
            { title: 'Order No', field: 'orderno' },
            {
                title: 'Message', field: 'message',
                // cellStyle: {
                //     maxWidth: '500px',
                //     textOverflow: 'ellipsis'
                // }
            },
            { title: 'Date', field: 'createdon' },
            {
                title: 'Action',
                field: 'id',
                export: false,
                render: rowData => (   
                    <div style={{ display: 'flex' }}>
                        {rowData.id && <Tooltip title="Mark as read" placement="top">
                            <IconButton aria-label="view" onClick={() => props.readNotification(rowData)}>
                                <CheckCircleOutlineIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>}
                        {rowData.id && <Tooltip title="View" placement="top">
                            <IconButton aria-label="view" onClick={() => props.onRowClick(rowData)}>
                                <VisibilityIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>}
                        {rowData.feedback === '1' && <Tooltip title="View Feedback" placement="top">
                               <IconButton
                                   aria-label="view"
                                   onClick={() => 
                                       props.onRowClickFbStatus(
                                            (JSON.parse(JSON.stringify(rowData)).orderno), (JSON.parse(JSON.stringify(rowData)).dsordersid), (JSON.parse(JSON.stringify(rowData)).feedback)
                                        )
                                    }
                               >
                                <StarBorderIcon style={{ color: 'orange', fontSize: 25 }} />
                               </IconButton>
                        </Tooltip>}
                    </div>
                ),
                cellStyle: {
                    padding: '0px'
                }
            }
        ],
        data: props.notifications
    });
    // // ==> console.error(props.isWaiting, 'four');
    return (
        <div className={classes.root}>
            <Grid container justify="center" alignItems="center" >
                <Grid item xs={12} sm={12} md={12}>
                    <div>
                        <Tooltip title="Refresh" placement="top" arrow>
                            <Fab color="primary" aria-label="add" style={{ height: '40px', width: '40px', float: 'left', margin: '12px', zIndex: 100 }} onClick={props.reload}>
                                <AutorenewIcon />
                            </Fab>
                        </Tooltip>
                        {props.notifications.length > 0 && props.notifications[0].id && <Tooltip title="Mark all as read" placement="top" arrow>
                            <IconButton aria-label="Mark-all-as-read" className={classes.buttonSend} onClick={props.readAllNotification}>
                                <DoneAllIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>}
                        <MaterialTable
                            title="Notifications"
                            columns={state.columns}
                            data={props.notifications}
                            localization={{
                                header: {
                                    actions: ''
                                }
                            }}
                            options={{
                                // pageSizeOptions: [5, 10, 25, 50, 100],
                                paging: false,
                                sorting: true,
                                actionsColumnIndex: -1,
                                headerStyle: {
                                    backgroundColor: '#757575',
                                    color: '#fff',
                                    // padding: '5px 0px',
                                    textAlign: 'left'
                                }
                            }}
                        />
                    </div>
                </Grid>
            </Grid>
        </div>
    );
};

export default PaidInvoiceView;



// WEBPACK FOOTER //
// ./src/components/layouts/NotificationsView.tsx